/**
 * Convert an integer (1–20) into a Roman numeral.
 * Sufficient for onboarding wizards with up to 20 chapters.
 */
export function toRoman(num: number): string {
    if (num <= 0 || num >= 21) return String(num);
    const map: [number, string][] = [
        [10, 'X'],
        [9, 'IX'],
        [5, 'V'],
        [4, 'IV'],
        [1, 'I'],
    ];
    let n = num;
    let result = '';
    for (const [val, sym] of map) {
        while (n >= val) {
            result += sym;
            n -= val;
        }
    }
    return result;
}
